var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 257,
    viewBox: "0 0 290 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.943 190.783L69.7773 181.974L86.2229 172.477L101.389 181.286L84.943 190.783Z",
    fill: "#726C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0876 250.518L54.922 241.709L54.8145 204.957L69.9801 213.766L70.0876 250.518Z",
    fill: "#474343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.442 221.661L16.2871 212.852L54.782 190.631L69.9369 199.44L31.442 221.661Z",
    fill: "#726C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9383 199.442L54.7834 190.633L54.6543 145.566L69.8092 154.375L69.9383 199.442Z",
    fill: "#474343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4069 245.271L0.24125 236.462L0.208984 224.416L15.3746 233.225L15.4069 245.271Z",
    fill: "#474343"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8112 154.37L54.6562 145.615C54.6562 138.559 54.8176 131.389 55.1403 124.104L70.2951 132.912C69.951 140.183 69.7896 147.354 69.8112 154.424",
    fill: "#454242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5299 116.805L52.375 107.996L69.5412 98.0898L84.6961 106.899L67.5299 116.805Z",
    fill: "#726C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3746 233.226L0.208984 224.417L52.3744 107.996L67.5293 116.805L15.3746 233.226Z",
    fill: "#5C5858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9433 190.793L101.389 181.296V195.623L84.9433 205.12L85.0509 241.873L70.0573 250.477L69.9498 213.725L15.375 245.228V233.193L67.5297 116.805L84.7389 106.898L84.9433 190.793ZM69.81 154.385C69.81 147.329 69.9713 140.159 70.294 132.874L69.7562 133.186C66.1637 143.167 63.3027 150.653 60.076 158.763L31.4656 221.232V221.652L69.939 199.398L69.81 154.331",
    fill: "#666161"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M254.248 93.0329L239.082 84.2239L255.538 74.7266L270.693 83.5355L254.248 93.0329Z",
    fill: "#726C6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 152.769L224.228 143.96L224.131 107.197L239.286 116.006L239.393 152.769Z",
    fill: "#474343"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.759 123.915L185.594 115.106L224.089 92.8848L239.244 101.694L200.759 123.915Z",
    fill: "#726C6C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.243 101.692L224.088 92.8831L223.959 47.8164L239.125 56.6254L239.243 101.692Z",
    fill: "#474343"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.713 147.523L169.558 138.714L169.525 126.668L184.68 135.477L184.713 147.523Z",
    fill: "#474343"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.125 56.6252L223.959 47.8162C223.959 40.7604 224.12 33.5899 224.443 26.3047L239.609 35.1136C239.264 42.3845 239.103 49.5551 239.125 56.6252Z",
    fill: "#454242"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.847 19.0559L221.682 10.2469L238.848 0.330078L254.013 9.13906L236.847 19.0559Z",
    fill: "#726C6C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M184.68 135.476L169.525 126.667L221.68 10.2461L236.846 19.0551L184.68 135.476Z",
    fill: "#5C5858"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.25 93.0337L270.696 83.5363V97.8522L254.25 107.35L254.358 144.113L239.364 152.771L239.256 116.008L184.682 147.522V135.476L236.847 19.0555L254.056 9.13867L254.25 93.0337ZM239.127 56.6254C239.127 49.5696 239.289 42.3991 239.611 35.1138L239.063 35.4258C235.47 45.3964 232.609 52.8824 229.383 61.003L200.783 123.472V123.892L239.299 101.692L239.17 56.6254",
    fill: "#666161"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M245.357 213.607V231.138C245.357 222.351 233.601 211.273 212.885 199.312C205.339 194.901 197.481 191.047 189.373 187.782V170.25C197.484 173.509 205.343 177.363 212.885 181.78C233.612 193.741 245.389 204.808 245.357 213.607Z",
    fill: "#454242"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.375 170.25V187.782C185.696 186.34 182.115 185.103 178.619 184.114V166.582C182.263 167.624 185.853 168.848 189.375 170.25Z",
    fill: "#474444"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.639 166.583V184.115C176.438 183.491 174.287 182.957 172.186 182.512V164.98C174.337 165.411 176.488 165.948 178.639 166.583Z",
    fill: "#4A4747"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.163 164.979V182.51C170.603 182.188 169.076 181.919 167.57 181.704V164.172C169.076 164.387 170.614 164.656 172.163 164.979Z",
    fill: "#4D4949"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M167.572 164.172V181.704C166.303 181.521 165.066 181.382 163.84 181.285V163.742C165.066 163.85 166.314 163.99 167.572 164.172Z",
    fill: "#4F4C4C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.84 163.742V181.285C162.764 181.188 161.689 181.134 160.613 181.102L160.667 163.57C161.743 163.57 162.818 163.656 163.894 163.742",
    fill: "#524E4E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M160.612 163.57L160.558 181.113C159.547 181.113 158.558 181.113 157.59 181.113V163.581C158.569 163.581 159.558 163.581 160.569 163.581",
    fill: "#545151"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.632 163.582V181.114C156.642 181.114 155.674 181.211 154.717 181.308L154.771 163.776C155.717 163.679 156.696 163.614 157.675 163.582",
    fill: "#575353"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.728 163.775L154.674 181.307C153.598 181.415 152.544 181.565 151.512 181.759V164.216C152.587 164.034 153.598 163.883 154.685 163.775",
    fill: "#5A5656"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.557 164.215V181.757C150.017 182.033 148.497 182.414 147.008 182.898V165.366C148.492 164.877 150.009 164.493 151.547 164.215",
    fill: "#5C5858"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.017 165.367V182.899C145.029 183.542 143.115 184.393 141.306 185.437L141.059 185.588V168.056L141.317 167.906C143.126 166.861 145.04 166.01 147.028 165.367",
    fill: "#5F5B5B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.047 168.057V185.589C140.011 186.209 139.038 186.929 138.143 187.74L138.196 170.208C139.084 169.393 140.054 168.672 141.09 168.057",
    fill: "#5C5858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.185 170.186L138.132 187.717C137.623 188.185 137.152 188.692 136.723 189.234V171.702C137.156 171.16 137.63 170.653 138.142 170.186",
    fill: "#5A5656"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.735 171.701V189.233C136.389 189.672 136.076 190.135 135.799 190.621L135.853 173.078C136.13 172.599 136.439 172.139 136.778 171.701",
    fill: "#575353"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M135.81 173.078L135.757 190.621C135.502 191.064 135.287 191.528 135.111 192.008V174.476C135.295 173.995 135.514 173.527 135.767 173.078",
    fill: "#545151"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M135.154 174.479V192.01C134.973 192.489 134.833 192.982 134.734 193.484V175.952C134.835 175.451 134.975 174.958 135.154 174.479Z",
    fill: "#524E4E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M134.734 175.949V193.481C134.624 194.027 134.563 194.581 134.551 195.138V177.606C134.567 177.049 134.629 176.496 134.734 175.949Z",
    fill: "#4F4C4C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M134.551 177.607V195.139C134.546 195.222 134.546 195.304 134.551 195.387L134.605 177.855V177.607",
    fill: "#4D4949"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M264.514 211.371V228.914C264.514 229.043 264.514 229.183 264.514 229.322L264.567 211.791V211.371",
    fill: "#4D4949"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M264.512 211.791L264.458 229.323C264.436 230.252 264.332 231.177 264.146 232.087L264.2 214.555C264.38 213.644 264.484 212.719 264.512 211.791Z",
    fill: "#4F4C4C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M264.202 214.555L264.148 232.087C263.974 232.98 263.726 233.858 263.406 234.711V217.168C263.724 216.318 263.976 215.444 264.159 214.555",
    fill: "#524E4E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M263.451 217.168V234.711C263.111 235.609 262.701 236.479 262.225 237.314V219.782C262.699 218.943 263.108 218.069 263.451 217.168Z",
    fill: "#545151"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M262.221 219.836V237.368C261.661 238.346 261.028 239.281 260.328 240.164L260.382 222.632C261.079 221.749 261.708 220.814 262.264 219.836",
    fill: "#575353"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M260.342 222.578L260.288 240.11C259.346 241.292 258.314 242.4 257.201 243.423V225.88C258.317 224.861 259.353 223.757 260.299 222.578",
    fill: "#5A5656"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M257.241 225.881V243.424C255.041 245.4 252.649 247.151 250.1 248.651L250.153 231.119C252.7 229.616 255.089 227.861 257.284 225.881",
    fill: "#5C5858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250.111 231.117L250.057 248.649L249.325 249.079C246.103 250.94 242.692 252.454 239.15 253.597L239.204 236.054C242.745 234.913 246.155 233.402 249.379 231.547L250.111 231.117Z",
    fill: "#5F5B5B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M239.207 236.055L239.153 253.597C236.463 254.465 233.717 255.151 230.936 255.652V238.12C233.719 237.621 236.464 236.931 239.153 236.055",
    fill: "#5C5858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M230.988 238.117V255.649C229.116 255.993 227.202 256.262 225.244 256.456L225.298 238.913C227.255 238.72 229.17 238.454 231.041 238.117",
    fill: "#5A5656"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M225.244 238.916L225.19 256.459C223.512 256.62 221.791 256.738 220.049 256.792L220.103 239.26C221.845 239.196 223.555 239.088 225.244 238.916Z",
    fill: "#575353"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M220.104 239.26L220.05 256.792C218.362 256.856 216.641 256.856 214.898 256.792V239.26C216.652 239.26 218.362 239.26 220.061 239.26",
    fill: "#545151"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M214.94 239.282V256.814C213.143 256.814 211.315 256.674 209.465 256.512V238.98C211.315 239.131 213.133 239.239 214.929 239.282",
    fill: "#524E4E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.476 238.979V256.511C207.476 256.35 205.432 256.124 203.367 255.823L203.421 238.291C205.486 238.581 207.519 238.818 209.53 238.979",
    fill: "#4F4C4C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.367 238.292L203.313 255.824C200.968 255.494 198.584 255.078 196.16 254.576V237.033C198.58 237.539 200.979 237.958 203.324 238.292",
    fill: "#4D4949"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M196.203 237.045V254.588C193.149 253.949 190.044 253.182 186.889 252.286L186.942 234.754C190.094 235.657 193.202 236.421 196.246 237.045",
    fill: "#4A4747"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.899 234.744L186.845 252.276C182.378 251.007 177.832 249.462 173.207 247.64V230.098C177.832 231.915 182.392 233.464 186.856 234.744",
    fill: "#474444"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.251 230.096V247.639C165.391 244.522 157.761 240.856 150.416 236.668C126.689 222.965 115.503 209.424 115.535 197.807L115.589 180.275C115.589 191.892 126.743 205.433 150.459 219.136C157.805 223.318 165.435 226.981 173.294 230.096",
    fill: "#454242"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M227.97 172.175C267.906 195.235 275.231 216.521 249.385 231.547C226.582 244.798 189.636 241.345 150.431 219.135C111.044 196.386 106.225 174.057 129.931 160.29C154.508 145.995 190.572 150.588 227.97 172.175ZM166.404 210.057C196.939 227.685 223.624 232.278 237.983 223.932C254.117 214.542 242.888 199.097 212.89 181.78C183.979 165.087 157.649 158.408 141.311 167.905C127.489 175.939 134.416 191.568 166.404 210.057Z",
    fill: "#726D6D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.c5f7ce37e65fdd5c212cd0242ae04586.svg";
export { ForwardRef as ReactComponent };